import * as React from 'react';

import { Grid, Group, Title } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import PageHeader from 'components/PageHeader';

import Exceptions from './components/Exceptions';
import WeeklySchedule from './components/WeeklySchedule';

const Availability = (): JSX.Element => {
  const [isWeeklyScheduleEditable, { toggle: toggleWeeklyScheduleEditable }] = useDisclosure(false);

  return (
    <>
      <PageHeader>
        <Group position='apart' align='center' noWrap>
          <Title order={1} size='h1'>
            Availability
          </Title>
        </Group>
      </PageHeader>

      <Grid p={0} m={0} gutter={0} columns={2}>
        <WeeklySchedule
          isWeeklyScheduleEditable={isWeeklyScheduleEditable}
          toggleWeeklyScheduleEditable={toggleWeeklyScheduleEditable}
        />
        <Exceptions isWeeklyScheduleEditable={isWeeklyScheduleEditable} />
      </Grid>
    </>
  );
};

export default Availability;
